// ** MUI Imports
import { updateUser } from '@/@core/services/app.service'
import { isWindow } from '@/@core/utils/utils'
import { FilterAlt, FilterAltOff } from '@mui/icons-material'
import { Tooltip } from '@mui/material'
import IconButton from '@mui/material/IconButton'

// ** Icons Imports
import WeatherNight from 'mdi-material-ui/WeatherNight'
import WeatherSunny from 'mdi-material-ui/WeatherSunny'
import React from 'react'
import { useMutation } from 'react-query'

// ** Type Import
import { Settings } from 'src/@core/context/settingsContext'

const FilterSelect = React.forwardRef(
  (
    props: {
      setFilterToggle?: any
    },
    ref
  ) => {
    const [flag, setFlag] = React.useState(true)
    const user = JSON.parse(localStorage.getItem('user') || '{}')

    React.useEffect(() => {
      //

      if (user && user.filterToggle) {
        setFlag(false)
      } else {
        setFlag(true)
      }
    }, [])

    React.useEffect(() => {
      props.setFilterToggle && props.setFilterToggle(flag)
    }, [flag])

    const updateUserMutation = useMutation(updateUser, {
      onSuccess: (data, params) => {
        const user = JSON.parse(localStorage.getItem('user') || '{}')

        localStorage.setItem(
          'user',
          JSON.stringify({
            ...user,
            filterToggle: !params.filterToggle
          })
        )
      }
    })

    const handleFilterToggle = () => {
      const user = JSON.parse(localStorage.getItem('user') || '{}')

      const params = {
        ...user,
        filterToggle: false
      }

      if (flag) {
        setFlag(false)

        params.filterToggle = false
      } else {
        setFlag(true)

        params.filterToggle = true
      }

      updateUserMutation.mutateAsync(params)
    }

    React.useImperativeHandle(ref, () => {
      return {
        filterToggle: flag
      }
    })

    return (
      <Tooltip title={'过滤模式切换，开启为表头过滤，禁用为过滤器过滤'}>
        <IconButton
          color="inherit"
          aria-haspopup="true"
          onClick={handleFilterToggle}
        >
          {!flag ? <FilterAlt /> : <FilterAltOff />}
        </IconButton>
      </Tooltip>
    )
  }
)

export default FilterSelect
